import {
  MediaContentInterface,
  MediaContentTypes,
  PlayerMediaTitleInterface
} from '@splixer/common';
import { Expose, Transform } from 'class-transformer';
import { AnyHash, nString, Uuid } from '@hidat/huijs-common';
import { dayjsTransformer } from '@hidat/huijs-dates';
import * as dayjs from 'dayjs';

export class PlayerMediaTitle implements PlayerMediaTitleInterface {
  @Expose({ name: 'uid' })
  uid: Uuid | undefined;
  @Expose({ name: 'seq_num' })
  seqNum: number = 0;
  @Expose({ name: 'audio_offset' })
  audioOffset: number = 0;

  @Expose({ name: 'broadcasted_at' })
  @Transform(dayjsTransformer)
  broadcastedAt: dayjs.Dayjs | undefined;
  @Expose({ name: 'duration' })
  duration: number | undefined;
  @Expose({ name: 'content_type' })
  contentType: MediaContentTypes | undefined;

  @Expose({ name: 'content' })
  content: MediaContentInterface | AnyHash | undefined;
  @Expose({ name: 'traits' })
  traits: AnyHash | undefined;
  @Expose({ name: 'comment' })
  comment: nString;

  // Keep compiler happy
  id = -1;
  createdAt: dayjs.Dayjs | undefined = undefined;
  updatedAt: dayjs.Dayjs | undefined = undefined;
  status = 100;
}
